/* TODO: should most of this go away in favor of more specific calendar styles? */
.month {
  margin: 5px;
  border-collapse: collapse;
}
.day, .month_row, .weekday {
  background-color: #eee;
  border: 1px solid black;
  user-select: none;
}
.month_row {
  /* todo vars for these sizes */
  height: 30px;
  text-align: center;
}
.month_row {
  color: #444;
}

.day {
  width: 60px;
  height: 60px;
  font-size: var(--font-size-md);
  color: #848484;
  /* vertical-align: top; */

  a {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    &:hover {
      text-decoration: none;
    }

    time {
      font-size: var(--font-size-sm);
      text-align: right;
      line-height: 1;
      color: gray;
    }
  
    .day_count {
      font-size: large;
      text-align: center;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }  
  }


}

